import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import type { CampaignDetailsResponse } from '~/types/monitoring';

export const GET_CAMPAIGN_DETAILS_QUERY_KEY = 'GET_CAMPAIGN_DETAILS_QUERY';

async function getCampaignDetails(campaignId: number) {
  const response = await serviceApi.get<CampaignDetailsResponse>(
    `/Campanha?id=${campaignId}`
  );
  return response.data;
}

export function useGetCampaignDetails(campaignId: number, enabled = true) {
  return useQuery({
    queryKey: [GET_CAMPAIGN_DETAILS_QUERY_KEY, campaignId],
    queryFn: () => getCampaignDetails(campaignId),
    staleTime: 1000 * 60 * 5,
    enabled: enabled && campaignId > 0,
  });
}

export type UseGetCampaignDetailsReturn = ReturnType<
  typeof useGetCampaignDetails
>['data'];
